import type { ReactNode } from "react";

import { cn } from "../lib/utils.js";

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <header
      data-slot="page-header"
      className={cn("flex shrink-0 items-start justify-between gap-4", className)}
    >
      <div className="min-w-0 space-y-2">
        <h1 className="font-semibold text-3xl text-neutral-900 leading-tight dark:text-neutral-100">
          {title}
        </h1>
        {description ? (
          <p className="text-neutral-600 text-sm dark:text-neutral-400">{description}</p>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </header>
  );
}
